  import React, { useEffect, useState, useCallback } from "react";
  import {
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Row,
    Table,
    Button,
    Modal,
    ModalBody,
    Label,
    ModalHeader,
    FormGroup,
    ModalFooter,
  } from "reactstrap";
  import { useNavigate, useParams } from "react-router-dom";
  import RejectCandidate from "./RejectCandidate";
  import SingleReject from "./SingleReject";
  import SingleNextRound from "./SingleNextRound";
  import BulkNextRound from "./BulkNextRound";
  import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
  import { CustomButton } from "components/CommonInputs/CustomButtons/CustomButton";
  import { get, post, uri } from "helpers/api_helper";
  import * as api from "../../constants/api_constants";
  import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
  import CustomPagination from "components/CustomPagination";

  const JobDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [modal, setModal] = useState(false);
    const [option, setOption] = useState("new");
    const [selectedCandidateId, setSelectedCandidateId] = useState("");
    const [jobDetails, setJobDetails] = useState();
    const [candidatesData, setCandidatesData] = useState([]);
    const [candidateDetailsLyt, setCandidateDetailsLyt] = useState([]);
    const [apiStatus, setApiStatus] = useState({ loading: false, error: "" });
    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [showAddCandidate, setShowAddCandidate] = useState(false);
    const [showSingleReject, setShowSingleReject] = useState(false);
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [showBulkNextRound, setShowBulkNextRound] = useState(false);
    const [showSingleNextRound, setShowSingleNextRound] = useState(false);
    const [selectedNextRoundCandidate, setSelectedNextRoundCandidate] =
      useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [fileModal, setFileModal] = useState({ open: false, url: "" });

    const toggle = () => setModal(!modal);
    const closeModal = () => setShowAddCandidate(false);
    const openModal = () => setShowAddCandidate(true);
    const openBulkNextRoundModal = () => setShowBulkNextRound(true);
    const closeBulkNextRoundModal = () => setShowBulkNextRound(false);
    const openSingleRejectModal = (candidate) => {
      setSelectedCandidate(candidate);
      setShowSingleReject(true);
    };
    const closeSingleRejectModal = () => {
      setSelectedCandidate(null);
      setShowSingleReject(false);
    };
    const openSingleNextRoundModal = (candidate) => {
      setSelectedNextRoundCandidate(candidate);
      setShowSingleNextRound(true);
    };
    const closeSingleNextRoundModal = () => {
      setSelectedNextRoundCandidate(null);
      setShowSingleNextRound(false);
    };
    const handleFileModal = () => {
      setFileModal((prev) => ({ ...prev, open: false, url: "" }));
    };

    const handleCheckboxChange = (candidateId) => {
      setSelectedCandidates((prevSelected) =>
        prevSelected.includes(candidateId)
          ? prevSelected.filter((id) => id !== candidateId)
          : [...prevSelected, candidateId]
      );
    };

    const handleOptionChange = (e) => {
      setOption(e.target.value);
      if (e.target.value !== "existing") {
        setSelectedCandidateId("");
      }
    };

    const handleCandidateSelect = (e) => {
      const value = e.target.value;
      console.log("Selected candidate ID:", value);
      setSelectedCandidateId(value);
    };

    const handleViewResume = async (candidate) => {
      
    const resumeId = parseInt(candidate.resumeSupportingDocDto?.uploadResume, 10);

      if (!resumeId) {
        showErrorToast("No resume available for this candidate");
        return;
      }

      setApiStatus({ loading: true, error: "" });
      try {
        const response = await get(
          `${uri}/fileservice/api/files/view/${resumeId}`
        );
        console.log("fileResponse", response);

        if (response && response.fileContent) {
          const byteCharacters = atob(response.fileContent);
          const byteArray = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteArray[i] = byteCharacters.charCodeAt(i);
          }

          const fileTypeList = response?.fileName?.split(".");
          const fileType = fileTypeList[fileTypeList.length - 1]?.toLowerCase();
          const mimeTypes = {
            pdf: "application/pdf",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          };
          const mimeType = mimeTypes[fileType] || "application/octet-stream";
          const blob = new Blob([byteArray], { type: mimeType });
          const url = URL.createObjectURL(blob);

          if (fileType === "pdf") {
            window.open(url, "_blank", "noopener,noreferrer");
          } else {
            setFileModal({ open: true, url });
          }
        } else {
          showErrorToast("Resume file content not found");
        }
      } catch (error) {
        console.error(`Error fetching resume ${resumeId}:`, error);
        showErrorToast(`Failed to fetch resume: ${error.message}`);
      } finally {
        setApiStatus((prev) => ({ ...prev, loading: false }));
      }
    };

    const handleNext = useCallback(async () => {
      if (!id || isNaN(parseInt(id))) {
        showErrorToast("Invalid job ID");
        return;
      }
      if (apiStatus.loading) {
        console.log("API call already in progress, skipping...");
        return;
      }
      if (option === "new") {
        toggle();
        navigate(`/add-newcandidate/${jobDetails?.id}`);
      } else if (option === "existing" && selectedCandidateId) {
        setApiStatus({ loading: true, error: "" });
        try {
          const candidateIdNum = parseInt(selectedCandidateId);
          if (isNaN(candidateIdNum)) {
            throw new Error("Invalid candidate ID");
          }
          const applyPayload = {
            candidateId: [candidateIdNum],
            jobId: parseInt(id),
          };
          console.log("Apply payload:", applyPayload);
          const response = await post(api.CANDIDATE_APPLY_FOR_JOB, applyPayload);
          console.log("API response:", response);
          showSuccessToast(
            `Candidate ${selectedCandidateId} applied successfully`
          );
          setSelectedCandidateId("");
          toggle();
          await fetchJobDetails();
        } catch (error) {
          console.error("API error:", error);
          showErrorToast(`Failed to apply candidate: ${error.message}`);
          setApiStatus({
            loading: false,
            error: `Failed to apply candidate: ${error.message}`,
          });
        } finally {
          setApiStatus((prev) => ({ ...prev, loading: false }));
        }
      } else {
        showErrorToast("Please select a candidate");
      }
    }, [id, option, selectedCandidateId, jobDetails, apiStatus.loading]);

    useEffect(() => {
      const fetchData = async () => {
        setApiStatus({ loading: true, error: "" });
        try {
          await fetchJobDetails();
          await fetchCandidatesLight();
        } catch (error) {
          console.error("Fetch data error:", error);
          showErrorToast("Failed to fetch data");
        } finally {
          setApiStatus((prev) => ({ ...prev, loading: false }));
        }
      };
      fetchData();
    }, [id]);

   const fetchJobDetails = async (page = currentPage) => {
    debugger
   
    try {
      console.log("Fetching job details for ID:", id, "Page:", page);
      const response = await post(api.JOBS_GET_BY_ID, {
        id: parseInt(id),
        page: page -1,
        pageSize: 10,
      });
      console.log("Full API response:", response);
      setJobDetails(response.data);
      const candidates = Array.isArray(response.data?.candidates)
        ? response.data.candidates
        : [];
      setCandidatesData(candidates);
      setTotalPages(response.data.totalPages );
      console.log("Set candidatesData:", candidates);
    } catch (error) {
      console.error("fetchJobDetails error:", error);
      showErrorToast(`Error fetching job details: ${error.message}`);
      setCandidatesData([]);
    }
  };

    const fetchCandidatesLight = async () => {
      try {
        const responseLight = await get(api.GET_ALL_CANDIDATES_LIGHT);
        console.log("fetchCandidatesLight response:", responseLight.data);
        const uniqueCandidates = Array.isArray(responseLight?.data)
          ? [
              ...new Map(
                responseLight.data.map((item) => [item.id, item])
              ).values(),
            ]
          : [];
        const availableCandidates = uniqueCandidates.filter(
          (candidate) =>
            !candidatesData.some((c) => c.candidateId === candidate.id)
        );
        console.log("Filtered available candidates:", availableCandidates);
        setCandidateDetailsLyt(availableCandidates);
      } catch (error) {
        console.error("fetchCandidatesLight error:", error);
        showErrorToast("Fetching candidates failed");
        setCandidateDetailsLyt([]);
      }
    };

    const handlePageChange = useCallback(
      (page) => {
        setCurrentPage(page);
        fetchJobDetails(page);
      },
      [fetchJobDetails]
    );

    return (
      <div className="page-content">
        <Container fluid className="py-0 px-0">
          <PageSubHeader
            heading={"View Job Details"}
            routePath={"Home"}
            pageName={jobDetails?.jobId || "JD1023"}
          />
          <Row className="px-4 py-4">
            <Row>
              <Col className="text-end">
                <Button
                  className="px-4 p-2 rounded-4 text-white"
                  style={{ background: "#006438" }}
                  onClick={toggle}
                >
                  +Add Candidate
                </Button>
              </Col>
            </Row>
            <Row className="pe-4 mt-2">
              <Row className="p-3 m-4 mt-1 data">
                <Row>
                  <Col size={4}>
                    <p className="info-head">Job ID</p>
                    <p className="info">{jobDetails?.jobId}</p>
                    <p className="info-head">Location</p>
                    <p className="info">{jobDetails?.jobLocation}</p>
                    <p className="info-head">Department</p>
                    <p className="info">{jobDetails?.department}</p>
                    <p className="info-head">Salary</p>
                    <p className="info">
                      {jobDetails?.fromSalary}-{jobDetails?.toSalary}
                    </p>
                    <p className="info-head">Total Applicants</p>
                    <p className="info">{jobDetails?.totalCandidates}</p>
                  </Col>
                  <Col size={4}>
                    <p className="info-head">Job Title</p>
                    <p className="info">{jobDetails?.jobTitle}</p>
                    <p className="info-head">Job Level</p>
                    <p className="info">{jobDetails?.jobLevel}</p>
                    <p className="info-head">Work Type</p>
                    <p className="info">{jobDetails?.workType}</p>
                    <p className="info-head">Job Posted On</p>
                    <p className="info">{jobDetails?.jobCreated}</p>
                  </Col>
                  <Col size={4}>
                    <p className="info-head">Company Name</p>
                    <p className="info">{jobDetails?.companyName}</p>
                    <p className="info-head">Number of Openings</p>
                    <p className="info">{jobDetails?.noOfOpenings}</p>
                    <p className="info-head">Pay Type</p>
                    <p className="info">{jobDetails?.payType}</p>
                    <p className="info-head">Job Expiry Date</p>
                    <p className="info">{jobDetails?.deadLineToApply}</p>
                  </Col>
                </Row>
                <Col className="d-flex align-items-center justify-content-end">
                  <Button
                    style={{
                      backgroundColor: "#006438",
                      color: "#FFFFFF",
                      borderRadius: "12px",
                    }}
                  >
                    View JD
                  </Button>
                </Col>
              </Row>
            </Row>
            <Row className="mt-2 px-4 d-flex align-items-center">
              <Col>
                <h2 className="heading">Applied Candidates</h2>
              </Col>
              {selectedCandidates.length > 1 && (
                <Col className="d-flex align-items-center justify-content-end gap-3">
                  <Button
                    style={{
                      backgroundColor: "#F93131",
                      color: "#FFFFFF",
                      borderRadius: "12px",
                      width: "113px",
                    }}
                    onClick={openModal}
                  >
                    Reject
                  </Button>
                  <CustomButton
                    text={" Move to Next Round"}
                    onClick={openBulkNextRoundModal}
                  />
                </Col>
              )}
            </Row>
            <Row className="mt-4 mx-0 px-4">
              <Card>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table mb-0 border: 0.4px solid #D4D4D4;">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Candidate ID</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Mobile</th>
                          <th>Source</th>
                          <th>Experience</th>
                          <th>Current CTC</th>
                          <th>Round</th>
                          <th>Status</th>
                          <th>Resume</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {apiStatus.loading ? (
                          <tr>
                            <td colSpan="12" className="text-center">
                              Loading candidates...
                            </td>
                          </tr>
                        ) : Array.isArray(candidatesData) &&
                          candidatesData.length > 0 ? (
                          candidatesData.map((candidate) => (
                            <tr key={candidate.candidateId}>
                              <td>
                                <Input
                                  type="checkbox"
                                  style={{ width: "17px", height: "17px" }}
                                  checked={selectedCandidates.includes(
                                    candidate.candidateId
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(candidate.candidateId)
                                  }
                                />
                              </td>
                              <td>{candidate.candidateId}</td>
                              <td>
                                {candidate.generalInfoCandidateDto.firstName}{" "}
                                {candidate.generalInfoCandidateDto.lastName}
                              </td>
                              <td>{candidate.generalInfoCandidateDto.email}</td>
                              <td>
                                {candidate.generalInfoCandidateDto.mobileNumber}
                              </td>
                              <td>{candidate.othersDto.source}</td>
                              <td>
                                {candidate.professionalDetailsDto.totalExperience}
                              </td>
                              <td>
                                {candidate.professionalDetailsDto.currentCtc}
                              </td>
                              <td>{candidate.roundType}</td>
                              <td>{candidate.status}</td>
                              <td>
                              {candidate.resumeSupportingDocDto?.uploadResume ? (
                                <i
                                  className="fa-solid fa-file-pdf"
                                  title="View Resume"
                                  style={{
                                    color: "#FF0000",
                                    fontSize: "19px",
                                    marginLeft: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleViewResume(candidate)}
                                />
                              ) : (
                                <i
                                  className="fa-solid fa-file-pdf"
                                  title="No Resume"
                                  style={{
                                    color: "#D3D3D3",
                                    fontSize: "19px",
                                    marginLeft: "5px",
                                  }}
                                />
                              )}
                            </td>
                              <td>
                                <div className="d-flex gap-2 align-items-center align-content-center">
                                  <i
                                    className="fa-solid fa-eye action-icon"
                                    title="View"
                                    onClick={() =>
                                      navigate(
                                        `/view-candidate-profile/${candidate.id}`,
                                        {
                                          state: { id: jobDetails?.id },
                                        }
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "5px",
                                    }}
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="12" className="text-center">
                              No candidates available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Row>
            <CustomPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </Row>
        </Container>
        <Modal
          isOpen={showAddCandidate}
          toggle={closeModal}
          centered
          backdrop="static"
          contentClassName="border-0 bg-transparent"
        >
          <ModalBody className="d-flex justify-content-center align-items-center p-0">
            <RejectCandidate closeModal={closeModal} />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={showSingleReject}
          toggle={closeSingleRejectModal}
          centered
          backdrop="static"
          contentClassName="border-0 bg-transparent"
        >
          <ModalBody className="d-flex justify-content-center align-items-center p-0">
            <SingleReject
              candidate={selectedCandidate}
              closeModal={closeSingleRejectModal}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={showSingleNextRound}
          toggle={closeSingleNextRoundModal}
          centered
          backdrop="static"
          contentClassName="border-0 bg-transparent"
        >
          <ModalBody className="d-flex justify-content-center align-items-center p-0">
            <SingleNextRound
              candidate={selectedNextRoundCandidate}
              closeModal={closeSingleNextRoundModal}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={showBulkNextRound}
          toggle={closeBulkNextRoundModal}
          centered
          backdrop="static"
          contentClassName="border-0 bg-transparent"
        >
          <ModalBody className="d-flex justify-content-center align-items-center p-0">
            <BulkNextRound
              candidates={candidatesData.filter((candidate) =>
                selectedCandidates.includes(candidate.candidateId)
              )}
              closeModal={closeBulkNextRoundModal}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={modal}
          toggle={toggle}
          centered
          style={{ width: "640px", height: "430px", borderRadius: "20px" }}
        >
          <ModalHeader toggle={toggle} className="fw-3">
            How do you want to add the candidates?
          </ModalHeader>
          <ModalBody>
            {apiStatus.loading && (
              <div className="text-center mb-3">Loading...</div>
            )}
            <FormGroup check>
              <Label
                check
                className="rounded-3 shadow-sm p-3 ps-4 d-flex align-items-center mb-3"
                style={{ gap: "10px", background: "#F5F6F8" }}
              >
                <Input
                  type="radio"
                  value="existing"
                  checked={option === "existing"}
                  onChange={handleOptionChange}
                  disabled={apiStatus.loading}
                />
                Select from existing candidates
              </Label>
              <Input
                type="select"
                name="existingCandidates"
                value={selectedCandidateId}
                onChange={handleCandidateSelect}
                disabled={option !== "existing" || apiStatus.loading}
                className="rounded-3 shadow-sm p-3 mb-3"
                style={{ background: "#F5F6F8" }}
              >
                <option value="">Select a candidate</option>
                {candidateDetailsLyt.map((candidate) => (
                  <option key={candidate.id} value={candidate.id}>
                    {candidate.firstName} {candidate.lastName}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup check>
              <Label
                check
                className="rounded-3 shadow-sm p-3 ps-4 d-flex align-items-center"
                style={{ gap: "10px", background: "#F5F6F8" }}
              >
                <Input
                  type="radio"
                  value="new"
                  checked={option === "new"}
                  onChange={handleOptionChange}
                  disabled={apiStatus.loading}
                />
                Add New Candidates
              </Label>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={toggle}
              className="border-success rounded-3 px-3 py-2"
              disabled={apiStatus.loading}
            >
              Cancel
            </Button>
            <Button
              className="px-4 py-2 rounded-3"
              color="success"
              onClick={handleNext}
              style={{ background: "#006438" }}
              disabled={apiStatus.loading}
            >
              {apiStatus.loading ? "Applying..." : "Next"}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={fileModal.open}
          toggle={handleFileModal}
          centered
          size="lg"
          backdrop="static"
        >
          <ModalHeader toggle={handleFileModal}>View Resume</ModalHeader>
          <ModalBody>
            {fileModal.url ? (
              <iframe
                src={fileModal.url}
                style={{ width: "100%", height: "500px" }}
                title="Resume"
              />
            ) : (
              <div className="text-center">No file available</div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleFileModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  };

  export default JobDetails;
